module.exports = __webpack_public_path__ + "img/G6.3ec4dc29.jpg";